// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"36":"8f63dba9","261":"6a87e53e","265":"e8ecbcb7","725":"3b639de8"}[chunkId] + ".css";
};